import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-2.5 left-2.5 z-50 max-w-[15.5rem]" data-id="element-145" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-146" data-mp="1175xy7vo5aih">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="pointer-events-auto flex items-start gap-2 rounded-lg border-2 border-brand-yellow bg-brand-blue p-2 shadow-[0_0_0_2px_var(--brand-carbon)]" data-id="element-147" data-mp="116mjj1589497">
            <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-brand-yellow" data-id="element-148" data-mp="x5u8c2csopaa">
              <CheckIcon size={12} className="text-brand-carbon" strokeWidth={3.5} data-id="element-149" data-mp="s5eul9olpfrs" />
            </span>
            <div className="min-w-0" data-id="element-150" data-mp="28j4zginjo82h">
              <p className="text-[0.68rem] font-bold leading-snug text-white" data-id="element-151" data-mp="28masg8zanu3h">
                {buyer.name} compró el Mega Pack
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[0.62rem] font-semibold leading-snug text-brand-yellow" data-id="element-152" data-mp="2anjj1f3zm77a">
                <MapPinIcon size={9} className="flex-shrink-0" data-id="element-153" data-mp="2fm36xl255t2a" />
                {buyer.city}, Argentina · hace {buyer.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="flex-shrink-0 rounded p-0.5 text-white/70 transition-colors duration-150 ease-soft hover:text-white" data-id="element-154" data-mp="2pm3s7cjkmj94">
              <XIcon size={12} data-id="element-155" data-mp="21wj8grflfhys" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}